import React from 'react';
import {
	IconButton,
	Menu,
	MenuItem,
	TableCell,
	TableRow,
	Typography
} from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import { useMenu } from 'hooks';

const EarnItem = ({ earnItem, handleClick }) => {
	const { open, anchorEl, handleToggleMenu, handleClose } = useMenu();

	const renderMenu = () => (
		<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
			<MenuItem onClick={(e) => handleEditClick(earnItem, e)}>Edit</MenuItem>
		</Menu>
	);

	return (
		<TableRow
			hover
			onClick={() => handleClick(earnItem)}
			sx={{ cursor: 'pointer' }}
		>
			<TableCell>
				<Typography variant="primary.text">{earnItem.name}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{earnItem.item}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{earnItem.coins}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{earnItem.xp}</Typography>
			</TableCell>
			<TableCell align="right">
				<IconButton
					onClick={(e) => {
						e.stopPropagation();
						handleToggleMenu(e);
					}}
				>
					<MoreHoriz />
				</IconButton>
				{renderMenu()}
			</TableCell>
		</TableRow>
	);
};

export default EarnItem;
